cartFetchAllProductStatus('true');
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let onsubmit_object = this;
      cartAddToCart(this.form.querySelector('[name=product_id]').value, this.form.querySelector('[name=product_handler]').value, this.form.querySelector('[name=product_is_soldout]').value).then(function (status_addtocart) {
        if (status_addtocart == 'true') {
          if (onsubmit_object.submitButton.getAttribute('aria-disabled') === 'true') return;
              onsubmit_object.handleErrorMessage();
              onsubmit_object.submitButton.setAttribute('aria-disabled', true);
              onsubmit_object.submitButton.classList.add('loading');
              onsubmit_object.querySelector('.loading-overlay__spinner').classList.remove('hidden');
              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];

          const formData = new FormData(onsubmit_object.form);
          if (onsubmit_object.cart) {
            formData.append('sections', onsubmit_object.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            onsubmit_object.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                onsubmit_object.handleErrorMessage(response.description);

                const soldOutMessage = onsubmit_object.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                onsubmit_object.submitButton.setAttribute('aria-disabled', true);
                onsubmit_object.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                onsubmit_object.error = true;
                return;
              } else if (!onsubmit_object.cart) {
                window.location = window.routes.cart_url;

                return;
              }

              onsubmit_object.error = false;
              const quickAddModal = onsubmit_object.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => {
                    onsubmit_object.cart.renderContents(response)
                  });
                }, {
                  once: true
                });
                quickAddModal.hide(true);
              } else {
                onsubmit_object.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              onsubmit_object.submitButton.classList.remove('loading');
              if (onsubmit_object.cart && onsubmit_object.cart.classList.contains('is-empty')) onsubmit_object.cart.classList.remove('is-empty');
              if (!onsubmit_object.error) onsubmit_object.submitButton.removeAttribute('aria-disabled');
              onsubmit_object.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });

        } else {
          console.log('FALSE_____________xxxxxxx');
        }

      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

  });
}